import { useFormik, FormikHelpers, FormikValues } from "formik";
import * as Yup from "yup";

import { ProfilePasswordFields } from "../../../components/ProfilePages/ProfilePassword/ProfilePassword";

interface UseProfilePasswordOptions {
  initialValues?: ProfilePasswordFields;
  onSubmit: (
    values: FormikValues,
    formikHelpers: FormikHelpers<ProfilePasswordFields>
  ) => Promise<any>;
}

export const useProfilePasswordFormik = (opts: UseProfilePasswordOptions) => {
  const ProfilePasswordSchema = Yup.object().shape({
    profilePassword: Yup.string()
      .min(5, "Passwordi duhet te kete se paku 5 karaktere!")
      .required("Passwordi eshte i nevojshem!"),
    confirmProfilePassword: Yup.string().oneOf(
      [Yup.ref("profilePassword")],
      "Fjalekalimi nuk perputhet!"
    ),
  });

  return useFormik({
    initialValues: {
      profilePassword: "",
      confirmProfilePassword: "",
    },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: ProfilePasswordSchema,
    onSubmit: async (values, formikHelpers) => {
      await opts.onSubmit(values, formikHelpers);
    },
  });
};

export type ProfilePasswordFormik = ReturnType<typeof useProfilePasswordFormik>;
